import axios, { AxiosInstance } from 'axios';

export default class ActivateService {
    private axios: AxiosInstance;

    constructor() {
        this.axios = axios;
    }

    public activate(activationKey: string, user: string, password: string[]): Promise<void> {
        return axios.put(`api/activate`, {
            key: activationKey,
            login: user,
            password: password[0],
            password2: password[1],
        });
    }
}
